export default {
  init() {

  },
  finalize() {
    // function checkboxClick($checkbox, $virtualCheckbox) {
    //   $checkbox.prop('checked', !$checkbox.prop('checked'));

    //   if ($checkbox.prop('checked')) {
    //     $virtualCheckbox.addClass('checkbox-checked');
    //   } else {
    //     $virtualCheckbox.removeClass('checkbox-checked');
    //   }

    // }
    $('#contact_job_details').attr('value', ($('.job-title').html()));

    // pick up checkboxes
    if ($('input[type="checkbox"]').length > 0) {
      $('input[type="checkbox"]').each(function () {
        const $this_ = $(this);

        $this_.removeClass();
        $this_.addClass('location-checkbox custom-control-input');
        $this_.siblings('span').removeClass().addClass('custom-control-label');
        $this_.parent().addClass('custom-control custom-checkbox');

        // // append custom checkbox
        // const $customCheckbox = $('<div class="checkbox-custom" tabindex="0"></div>');
        // $this_.parent().prepend($customCheckbox);

        // if ($this_.prop('checked')) {
        //   $customCheckbox.addClass('checkbox-checked');
        // }

        // // actions
        // $customCheckbox.parent().on('click', function () {
        //   checkboxClick($this_, $customCheckbox);
        // });

        // // keyboard
        // $customCheckbox.on('keydown', function (e) {
        //   if (e.keyCode == 32 || e.keyCode == 13) {
        //     e.preventDefault();
        //     e.stopPropagation();

        //     checkboxClick($this_, $customCheckbox);
        //   }
        // });
      });
    }

    // section togglers
    if ($('.section-toggle').length > 0) {
      $('.section-toggle').each(function () {
        $(this).on('click', function () {
          if ($(this).html() == '-') {
            $(this).html('+');
          } else {
            $(this).html('-');
          }

          $(this).closest('.section-group').find('.section-body').stop().slideToggle(300);
        });
      });
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/routes/template-job-application.js